/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./icon.component";
var styles_IconComponent = ["[_nghost-%COMP%] {\n      display: block;\n      min-height: 24px;\n      min-width: 24px;\n    }\n    .no-flex[_nghost-%COMP%]   [_nghost-%COMP%], .no-flex   [_nghost-%COMP%]   [_nghost-%COMP%] {\n      display: block;\n    }"];
var RenderType_IconComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_IconComponent, data: {} });
export { RenderType_IconComponent as RenderType_IconComponent };
export function View_IconComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_IconComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "nns-icon", [], [[8, "className", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) { var ad = true; if (("mouseenter" === en)) {
        var pd_0 = (i0.ɵnov(_v, 1).onMouseEnter() !== false);
        ad = (pd_0 && ad);
    } if (("mouseleave" === en)) {
        var pd_1 = (i0.ɵnov(_v, 1).onMouseLeave() !== false);
        ad = (pd_1 && ad);
    } return ad; }, View_IconComponent_0, RenderType_IconComponent)), i0.ɵdid(1, 573440, null, 0, i1.IconComponent, [], null, null)], null, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1)._classes; _ck(_v, 0, 0, currVal_0); }); }
var IconComponentNgFactory = i0.ɵccf("nns-icon", i1.IconComponent, View_IconComponent_Host_0, { icon: "icon", hoverIcon: "hoverIcon" }, {}, []);
export { IconComponentNgFactory as IconComponentNgFactory };
//# sourceMappingURL=icon.component.ngfactory.js.map